import saveAs from 'file-saver'

import ScreenReaderOnlyText from 'components/Editor/styled/ScreenReaderOnlyText'
import { useProjectT } from 'services/ProjectLabels'
import { sendReflection } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getProject } from 'services/Store/Project/selectors'
import { testPropsEl } from 'utils/test/qaData'

import { useElementCompleted } from '../../hooks/useElementCompleted'
import { useElementRootStyles } from '../../hooks/useElementRootStyles'
import * as s from './ReflectionElement.module.scss'
import IconDefaultDownload from './assets/defaultDownload.svg?react'
import type { ReflectionElementType } from './reflectionTypes'
import DownloadButtonStyled from './styled/DownloadButtonStyled'
import TextareaStyled from './styled/TextareaStyled'

const ReflectionElement: ReflectionElementType = ({
  element,
  styles,
  font,
  block,
  mode,
  state,
}) => {
  const rootStyles = useElementRootStyles(styles.root)
  const text = state?.value || ''
  const elementId = element.id
  const project = useProjectContext(getProject)
  const pt = useProjectT()
  const dispatch = useProjectDispatch()
  const questionText = pt('elements.reflection.placeholder')
  const textAreaId = `${element.id}-textArea`

  const setCompleted = useElementCompleted({
    block,
    elementId,
    deviceMode: mode.deviceMode,
    completed: false,
  })

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    dispatch(sendReflection({ value, elementId, questionText }))
    setCompleted(Boolean(value))
  }

  const handleDownload = () => {
    const projectName = project?.name || 'project'
    const date = new Date().toISOString().split('T')[0]
    const fileName = `${projectName}_${date}_reflection.txt`.replace(/[\\/:*?"<>| ]/g, '_')
    const blob = new Blob([String(text)], { type: 'text/plain;charset=utf-8' })
    saveAs(blob, fileName)
  }

  return (
    <div className={s.root} style={rootStyles}>
      <ScreenReaderOnlyText as='label' htmlFor={textAreaId}>
        Input
      </ScreenReaderOnlyText>
      <TextareaStyled
        $fonts={font}
        $styles={styles}
        id={textAreaId}
        maxLength={3500}
        name='reflection'
        onChange={handleChange}
        placeholder={questionText}
        value={text}
        {...testPropsEl('courseTextarea', {})}
      />
      {element.value.displayDownloadButton && (
        <DownloadButtonStyled $styles={styles} aria-label='Download' onClick={handleDownload}>
          {!styles.icon.backgroundImage && <IconDefaultDownload aria-hidden />}
        </DownloadButtonStyled>
      )}
    </div>
  )
}
export default ReflectionElement
